var supportedTypes = ['initial', 'all'];
/**
 * strips indentation from a template literal
 * @param  {String} type = 'initial' - whether to remove all indentation or just leading indentation. can be 'all' or 'initial'
 * @return {Object}                  - a TemplateTag transformer
 */

var stripIndentTransformer = function stripIndentTransformer(type) {
  if (type === void 0) {
    type = 'initial';
  }
  if (!supportedTypes.includes(type)) {
    throw new Error("Type not supported: " + type);
  }
  return {
    onEndResult: function onEndResult(endResult) {
      if (type === 'all') {
        // remove all indentation from each line
        return endResult.replace(/^[^\S\n]+/gm, '');
      } // remove the shortest leading indentation from each line

      var match = endResult.match(/^[^\S\n]*(?=\S)/gm);
      var indent = match && Math.min.apply(Math, match.map(function (el) {
        return el.length;
      }));
      if (indent) {
        var regexp = new RegExp("^.{" + indent + "}", 'gm');
        return endResult.replace(regexp, '');
      }
      return endResult;
    }
  };
};
export default stripIndentTransformer;